import { ToastCont } from "components/toast/ToastCont";
import NotPage from "pages/NotPage";
import BoardDetail from "pages/board/boardDetail/BoardDetail";
import BoardList from "pages/board/boardList/BoardList";
import BoardPost from "pages/board/boardPost/BoardPost";
import BoardUpdate from "pages/board/boardUpdate/BoardUpdate";
import FindPassword from "pages/findpassword/FindPassword";
import FindUser from "pages/finduser/FindUser";
import Login from "pages/login/Login";
import Main from "pages/main/Main";
import Index from "pages/mypage";
import Regist from "pages/regist/regist/Regist";
import Userregist from "pages/regist/userregist/Userregist";
import StudyRoomDetail from "pages/studyRoom/studyRoomDetail/StudyRoomDetail";
import StudyRoomInfo from "pages/studyRoom/studyRoomInfo/StudyRoomInfo";
import StudyRoom from "pages/studyRoom/studyRoomList/StudyRoom";
import StudyRoomPost from "pages/studyRoom/studyRoomPost/StudyRoomPost";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes, useLocation, Outlet, useSearchParams } from "react-router-dom";
import useGoogleLoginAuth from "useGoogleLoginAuth";
import useRefreshToken from "useRefreshToken";
import { NavigateMain, NavigatePost } from "./Outlet";
import Sse from "sse";
import { useEffect } from "react";
import useGetToken from "firebase-get-token";
import Header from "components/header/Header";
import classnames from "classnames";
import Footer from "components/footer/Footer";
import { SET_ROUTER } from "store/PageRouter";
import { getCookie } from "util/authCookie";
import { useQuery } from "react-query";
import { getUserInfoApi } from "api/auth";
import { SET_USER_INFO } from "store/User";
import MyStudyRoom from "pages/mypage/_com/mystudyroom/MyStudyRoom";
import MyMessage from "pages/mypage/_com/mymessage/MyMessage";
import Account from "pages/mypage/_com/account/Account";
import Notice from "pages/board/_com/notice/Notice";
// import createAxiosInstance from "./module/useInterceptor";

// FCM 테스트
// import "./firebase-get-token";
// import { messaging } from "./firebase-get-token";
// import { getToken } from "firebase/messaging";

function App() {
  const auth = useSelector((state) => state.authToken);
  const user = useSelector((state) => state.userStore);
  const dispatch = useDispatch();
  // createAxiosInstance();

  // async function requestPermission() {
  //   const permission = await Notification.requestPermission();
  //   if (permission === "granted") {
  //     const token = await getToken(messaging, {
  //       vapidKey: "BOWbgLD10kyQ6zwV8RpnBg84oLQCD6Ll1t2u0AWjDxd1-u3sbTNy1DbKHEvJpvgLrUAhinaytkHIDakxn0HETaI",
  //     });
  // console.log("쿠키", getCookie("dtrtk"));
  // console.log("access-token : ", auth.accessToken);
  //   } else if (permission === "denied") {
  //     console.log("denied");
  //   }
  // }
  // useEffect(() => {
  //   requestPermission();
  // }, []);

  // NOTE: 이 코드가 있어야 마이페이지에서 새로고침시 활동내역이 제대로 가져옴
  // const { data } = useQuery({
  //   queryKey: ["getuser"],
  //   queryFn: () => getUserInfoApi(),
  // });

  // if (data) {
  //   dispatch(SET_USER_INFO({ nickname: data.nickname, userid: data.userid }));
  // }
  // console.log("저장된 user", user);

  // console.log("auth", auth.accessToken);

  useGoogleLoginAuth();
  // useInterceptor();
  useRefreshToken();
  useGetToken();
  // Sse();
  return (
    <div className="App">
      <ToastCont />
      <Routes>
        <Route path="/" element={<NavigateMain />}>
          <Route index element={<Main />} />
          {/* <Route path="developer-talks-frontend" element={<Main />} /> */}
          {/* <Route exact path="/" element={<Main />} /> */}
          <Route path="user/*" element={<Index />} />

          <Route path="study-rooms" element={<StudyRoom />} />
          <Route path="post" element={<BoardList type="post" />} />
          <Route path="post/search/:keyword" element={<BoardList type="post" />} />
          <Route path="/post/:postId" element={<BoardDetail type="post" />} />
          <Route path="study-rooms/info/:postId" element={<StudyRoomInfo />} />
          <Route path="/study-rooms/:postId" element={<StudyRoomDetail />} />
          <Route path="questions" element={<BoardList type="questions" />} />
          <Route path="questions/search/:keyword" element={<BoardList type="questions" />} />
          <Route path="/questions/:postId" element={<BoardDetail type="questions" />} />
          {/* <Route path="notice" element={<Notice />} /> */}
          {/* <Route path="*" element={<NotPage />} /> */}
        </Route>

        <Route element={<NavigatePost />}>
          <Route path="study-rooms/post" element={<StudyRoomPost type="studyroom" />} />
          <Route path="/post/post" element={<BoardPost type="post" />} />
          <Route path="/questions/post" element={<BoardPost type="questions" />} />
          <Route path="/post/update/:postId" element={<BoardUpdate type="post" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/finduser" element={<FindUser />} />
          <Route path="/findpassword" element={<FindPassword />} />

          <Route path="/questions/update/:postId" element={<BoardUpdate type="questions" />} />
          <Route path="/regist" element={<Regist />} />
          <Route path="/login" element={<Login />} />
          <Route path="/userregist" element={<Userregist />} />
        </Route>
      </Routes>
    </div>
  );
}

// const NavigateMain = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const pageRouter = useSelector((state) => state.pageRouter);
//   const mypage = ["/mypage", "/my-studyroom", "/account"];

//   useEffect(() => {
//     if (mypage.includes(location.pathname)) {
//       dispatch(SET_ROUTER({ state: "mypage" }));
//     } else {
//       dispatch(SET_ROUTER({ state: null }));
//     }
//   }, [location, dispatch]);

//   return (
//     <>
//       <Header />
//       <div
//         className={classnames("page", {
//           "is-mypage": pageRouter.state === "mypage",
//         })}
//       >
//         <Outlet />
//       </div>
//       <Footer />
//     </>
//   );
// };

// // 헤더 미포함
// const NavigatePost = () => {
//   return (
//     <>
//       <div className="page">
//         <Outlet />
//       </div>
//       <Footer />
//     </>
//   );
// };

export default App;
